package streetlight.model.data

enum class PostResult {
    Posted,
    Conflict,
}